module.exports = __webpack_public_path__ + "static/media/grabaseat2_preview.bf9901a1.jpg";